module.exports = __webpack_public_path__ + "static/media/GRUPOS_BLANCO.e030aefa.svg";